fragment StagesetContext on Stageset {
    id
    pipelineName: name
    isThisTheDefaultPipeline: default
    stages {
        id
        stageName: name
        setConfidenceOnLeadWhenItEntersThisStage: defaultConfidence
        description
        position
        activeStepTemplates {
            id
            dueDate {
                dueFrom
                dueUnit
                dueTimespan
            }
            position
            name
            description
            assignee {
                id
                name
            }
            processTemplate {
                id
                name
                closedLeadAutomations {
                    outcomeType
                    emailAutomations {
                        id
                        emailList {
                            id
                            name
                        }
                    }
                    slackAutomations {
                        id
                        name
                    }
                    accountTypeAutomations {
                        id
                        accountType {
                            id
                            name
                        }
                        conditions {
                            id
                            type
                        }
                    }
                    # nutshellMarketingStartTriggers {
                    #     id
                    #     type
                    #     conditions {
                    #         id
                    #         type
                    #         humanReadableObjectiveString
                    #     }
                    #     humanReadableTitle
                    #     campaign {
                    #         id
                    #         name
                    #         description
                    #     }
                    # }
                }
                emailAutomations {
                    id
                    emailList {
                        id
                        name
                    }
                    entersStage {
                        id
                        name
                        description
                    }
                    exitsStage {
                        id
                        name
                        description
                    }
                    delay {
                        timespan
                    }
                    numberOfStagesSpanned
                    sendFromUser {
                        id
                        name
                    }
                }
                # nutshellMarketingStartTriggers {
                #     id
                #     type
                #     humanReadableTitle
                # }
            }
        }
    }
}
